module.exports = __webpack_public_path__ + "img/play_moka.f3b35af1.svg";